export const MUT_ADD_GOOD = 'MUT_ADD_GOOD';
export const MUT_RESET = 'MUT_RESET';
export const MUT_REMOVE_GOOD = 'MUT_REMOVE_GOOD';
export const MUT_UPDATE_GOOD_PRICE = 'MUT_UPDATE_GOOD_PRICE';
export const MUT_LOAD_STATE = 'MUT_LOAD_STATE';
